export class numberHelper {
  static numbersToWords(value: number): string {
    const numbersToWordsArray = ['zero', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten'];
    if (Number.isNaN(value)) {
      return '';
    }
    if (value > numbersToWordsArray.length - 1) {
      return value.toString();
    }
    return numbersToWordsArray[value];
  }
  static formatMoney(value: number, hideSymbol?: boolean): string {
    if (Number.isNaN(value)) {
      return '';
    }
    const formattedString = Number.isInteger(value) ? value.toString() : value.toFixed(2);
    return hideSymbol ? formattedString : `$${formattedString}`;
  }
}
